import { createContext } from 'react';

const personContext = createContext();

export default personContext;
